export const INTERSTITIAL_BANNER_WRAPPER_CLASS = 'interstitial-banner__wrapper'
